import { TemplateRef, Directive, inject } from '@angular/core';

@Directive({
  selector: '[selectSuffix]',
  standalone: false,
})
export class SelectSuffix {
  readonly tr = inject<TemplateRef<any>>(TemplateRef);
}
